import { SentimentBadge } from "subframe";

import { isNumber } from "utils/number";
import { isEmpty as isObjectEmpty } from "utils/object";
import { isEmpty as isStringEmpty } from "utils/string";

import { SENTIMENT, SURVEY_TYPE } from "../constants/constants";

/**
 * Initializes the sentiment on basis of the sentiment score.
 *
 * @param {Number} sentimentScore
 * @returns {Object}
 */
export const initializeSentiment = (sentimentScore, surveyResponseRate) => {
  if (surveyResponseRate === 0) {
    return SENTIMENT["No Data"];
  }

  switch (true) {
    case sentimentScore >= 70 && sentimentScore <= 100:
      return SENTIMENT.Positive;
    case sentimentScore >= 30 && sentimentScore <= 69:
      return SENTIMENT.Neutral;
    case sentimentScore >= -100 && sentimentScore <= 29:
      return SENTIMENT.Negative;
    default:
      return SENTIMENT["No Data"];
  }
};

/**
 * Renders the sentiment badge in the [${Emoji}${Sentiment}(${Score})] format.
 *
 * @param {String} score
 * @param {Number} surveyResponseRate
 * @param {Boolean} isFixedWidth
 * @returns {Component}
 */
export const renderSentimentBadgeWithScore = (
  score,
  surveyResponseRate,
  isFixedWidth = false
) => {
  if (!isNumber(score)) {
    return <></>;
  }

  const sentiment = initializeSentiment(score, surveyResponseRate);
  const scoreLabel = `${sentiment.label} ${
    surveyResponseRate === 0 ? "" : `(${score?.toString()})`
  }`;

  return (
    <SentimentBadge
      score={scoreLabel}
      variant={sentiment.value}
      className={isFixedWidth ? "w-[130px]" : "w-fit"}
    />
  );
};

/**
 * Renders the sentiment badge with Termination information.
 *
 * @param {String} reason
 * @param {Number} score
 * @param {Number} surveyResponseRate
 * @returns {Component}
 */
export const renderSentimentBadgeWithTermination = (
  reason,
  score,
  surveyResponseRate
) => {
  const sentiment = initializeSentiment(score, surveyResponseRate);

  return (
    <SentimentBadge
      className="w-fit"
      variant={sentiment.value}
      score={isStringEmpty(reason) ? "No Data" : reason}
    />
  );
};

export const renderSentimentBadge = (label, sentimentKey, type) => {
  const sentiment = isObjectEmpty(SENTIMENT[sentimentKey])
    ? SENTIMENT["No Data"]
    : SENTIMENT[sentimentKey];

  let scoreLabel;

  if (type === SURVEY_TYPE.MULTIPLE_CHOICE) {
    scoreLabel = `${sentiment.label} ${
      isStringEmpty(label)
        ? ""
        : `(${label})
`
    }`;
  } else {
    scoreLabel = isStringEmpty(label) ? "-" : label;
  }

  return (
    <SentimentBadge
      className="w-fit"
      variant={sentiment.value}
      score={scoreLabel}
    />
  );
};
